import { getCurrentUserSelector } from './../../@state/current-user/current-user.selector';
import { AppState } from './../../@state/app.state';
import { NotificationService } from './../services/notification.service';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class ProfileGuard implements CanActivate {
	constructor(
		private readonly router: Router,
		private readonly store: Store<AppState>,
		private readonly notificationService: NotificationService
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.isProfileComplete()) {
			return true;
		} else {
			this.router.navigate(['admin/profile']);
			this.notificationService.showPopupInfo('Please Update you Profile');
			return false;
		}
	}

	isProfileComplete() {
		let flag: boolean;
		this.store
			.select(getCurrentUserSelector)
			.pipe(untilDestroyed(this))
			.subscribe((currentUser) => {
				if (
					currentUser &&
					currentUser.firstName &&
					currentUser.lastName &&
					currentUser.email
				) {
					flag = true;
				} else {
					flag = false;
				}
			});
		return flag;
	}
}
